import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RegistrationProvider } from './contexts/RegistrationContext';
import Layout from './components/Layout';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import RegistrationStart from './components/Registration/RegistrationStart';
import RegistrationWizard from './components/Registration/RegistrationWizard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminRegistrations from './components/Admin/AdminRegistrations';
import AdminRegistrationDetail from './components/Admin/AdminRegistrationDetail';
import MyRequests from './components/User/MyRequests';
import MyRequestDetail from './components/User/MyRequestDetail';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <RegistrationProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route 
                path="/" 
                element={
                  <ProtectedRoute>
                    <RegistrationStart />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/registration/:id" 
                element={
                  <ProtectedRoute>
                    <RegistrationWizard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/my-requests" 
                element={
                  <ProtectedRoute>
                    <MyRequests />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/my-requests/:id" 
                element={
                  <ProtectedRoute>
                    <MyRequestDetail />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                } 
              />
              <Route 
                path="/admin/registrations" 
                element={
                  <AdminRoute>
                    <AdminRegistrations />
                  </AdminRoute>
                } 
              />
              <Route 
                path="/admin/registrations/:id" 
                element={
                  <AdminRoute>
                    <AdminRegistrationDetail />
                  </AdminRoute>
                } 
              />
            </Routes>
          </Layout>
        </Router>
      </RegistrationProvider>
    </AuthProvider>
  );
}

export default App;
